<template>
  <PageView class="" :page-reference="PAGE_REFERENCES.WORKSPACE" page-title="Workspaces">
    <template #body>
      <div class="mt-8 max-h-[95vh] overflow-visible">
        <WorkspacesSearchBar v-model:search-term="search_term" />
        <WorkspacesFilters @update:filters-and-sorting="($event) => handleFilterWorkspaces($event)" />
        <WorkspacesList
          :search-term="search_term"
          :filter-applied="filter_applied"
          :handle-check-click="handleCheckClick"
          :selected-workspaces="selected_workspaces" />
      </div>
    </template>
  </PageView>
</template>

<script>
import WorkspacesSearchBar from "./WorkspacesSearchBar.vue"
import WorkspacesList from "./WorkspacesList.vue"
import WorkspacesFilters from "../WorkspacesFilters.vue"
import { PAGE_REFERENCES } from "@/store/constants/references"
import PageView from "@/components/shared/pages/PageView.vue"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  name: "Workspace",
  components: {
    WorkspacesSearchBar,
    WorkspacesFilters,
    WorkspacesList,
    PageView
  },
  props: {},
  emits: [],
  data() {
    return {
      selected_workspaces: new Set(),
      search_term: "",
      filter_applied: false,
      PAGE_REFERENCES
    }
  },

  watch: {
    search_term() {
      this.getWorkspaces()
    }
  },

  created() {
    this.getWorkspaces()
    this.register_listeners()
  },
  activated() {
    this.register_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },

  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.WORKSPACE_ORGANIZATION_CHANGED, () => {
        this.getWorkspaces()
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.WORKSPACE_ORGANIZATION_CHANGED)
    },
    getWorkspaces() {
      let params = { page_size: 6 }
      if (this.search_term) {
        params["name"] = this.search_term
      }
      params["ordering"] = "-last_workspace_access"
      if (this.$store.state.auth.user.user_type == "end_user") {
        params["contacts"] = this.$store.state.auth.user.id
      } else {
        params["team_members"] = this.$store.state.auth.user.id
      }

      if (this.$store.state.auth.user.user_type == "end_user" && this.$store.state.data.workspace_organizations.length > 1) {
        params["organization"] = this.$store.state.data.selected_organization.id
      }

      this.$store.dispatch("data/getWorkspaces", params)
    },
    handleCheckClick(e, phase) {
      this.toggleSelectedWorkspace(phase, e.target.checked)
    },

    toggleSelectedWorkspace(workspace, isChecked) {
      if (isChecked) {
        this.selected_workspaces.add(workspace.short_id)
      } else {
        this.selected_workspaces.delete(workspace.short_id)
      }
    },

    handleFilterWorkspaces(filters) {
      let params = { page_size: 6 }
      this.filter_applied = false
      if (this.search_term) {
        params["name"] = this.search_term
      }
      if (filters.filter_by !== "all") {
        this.filter_applied = true

        if (filters.filter_by == "me") {
          params["created_by"] = this.$store.state.auth.user.id
        }

        const team_members_params_list = []
        const contacts_params_list = []
        if (filters.filtered_collaborators.length) {
          const contacts = filters.filtered_collaborators.filter((c) => c.user_type == "end_user")
          const team_members = filters.filtered_collaborators.filter((c) => c.user_type == "user")
          if (team_members.length) {
            team_members.forEach((t) => team_members_params_list.push(t.id))
          }
          if (contacts.length) {
            contacts.forEach((c) => contacts_params_list.push(c.id))
          }
        }
        params["team_members"] = team_members_params_list.join(",")
        params["contacts"] = contacts_params_list.join(",")
      }

      if (filters.sort_by == "access_date") {
        params["ordering"] = "-last_workspace_access"
      }

      if (filters.sort_by == "edit_date") {
        params["ordering"] = "-last_workspace_edit"
      }

      if (filters.sort_by == "alphabetical") {
        params["ordering"] = "name"
      }

      if (this.$store.state.auth.user.user_type == "end_user" && this.$store.state.data.workspace_organizations.length > 1) {
        params["organization"] = this.$store.state.data.selected_organization.id
      }

      this.$store.dispatch("data/getWorkspaces", params)
    }
  }
}
</script>
